import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading } from 'ionic-angular';
import * as page from '../../pages/pages';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {ecomBadgesApi, ecomUserApi} from './../../api/ecom/ecomApi';
import { LoginPage, BadgePage } from '../../pages/pages';
import {ApiConfig} from '../../shared/api-config.service'
import {AppConfig} from '../../shared/app-config.service'
import {LoggerService} from '../../shared/logger.service'
import { Storage } from '@ionic/storage';
import {BadgeModel} from "../../app/models/BadgeModel";
import { Observable, Observer } from 'rxjs';
import { GetEarnerRequest } from '../../api/swagger/ecomApi';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


declare var ecomSecurity: any;

@Component({
	selector: 'page-badges',
	templateUrl: 'badges.html',
	providers: [ecomUserApi, ecomBadgesApi, ApiConfig, LoggerService, AppConfig]
})
export class BadgesPage {

	userId:number;
	userBadges: any = [];
	offlineBadges: any = [];
	zeroData: boolean = false;
	displayData: boolean = false;
	connection: boolean = false;
	loading: boolean = false;
	id:number;
	base64Image: string;
	imageContainer: string;
	userName: string;
	lastSyncDate: string = "";
	organisationLogo: string = "";
	hasNetworkConnection: boolean;
	hasInternetAccess: boolean;
	status: string;

	constructor(
		public navCtrl: NavController,
		  private ecomBadgesApi: ecomBadgesApi, 
		  private ecomUsersApi: ecomUserApi,
      	private loadingCtrl: LoadingController, 
				private alertCtrl: AlertController,
				private log: LoggerService,
      	private storage: Storage,
				private iab: InAppBrowser,
				private apiConfig: ApiConfig
		) {
			this.lastSyncDate = localStorage.getItem("lastSyncDate") == this.getDate() ? "<span class='active'>Passes are valid for today: "+ this.getDate() +"</span>" : "<span class='expired'>Passes have expired and no longer valid</span>";
			this.storage.get('name').then(data => {
				this.userName = data;
			});
			this.storage.get('userId').then(data => {
				this.userId = Number(data);
				console.log("1 - userId = " + this.userId);
				console.log("2 - USR = " + localStorage.getItem("USR"));
				console.log("2.1 - USRID = " + localStorage.getItem("USRID"));
				console.log("2.2 - data = " + data);
				
				if (localStorage.getItem("USRID") == null)
				{
							ecomUsersApi.get(new GetEarnerRequest({
								email: null,
								userId: data
							})).subscribe(u => {
								console.log(u);
								var reader = new FileReader();
								reader.onload = function() {
									ecomSecurity.init(JSON.parse(reader.result.toString()).email, data.toString());
								}
								console.log("4 - reader data = " + u.data);
								reader.readAsText(u.data);
							});
					}
					else if(localStorage.getItem("USRID") != data.toString()) {
						ecomUsersApi.get(new GetEarnerRequest({
							email: null,
							userId: data
						})).subscribe(u => {
							console.log(u);
							var reader = new FileReader();
							reader.onload = function() {
								ecomSecurity.init(JSON.parse(reader.result.toString()).email, data.toString());
							}
							console.log("4 - reader data = " + u.data);
							reader.readAsText(u.data);
						});
					}
				console.log("5 - usr wasnt null");
			});
			this.storage.get("OrganisationLogo").then(data => {
				if (data != null && data != undefined){
					this.organisationLogo = data;
				}
			});
			this.imageContainer = apiConfig.BadgeContainer;
		}

	ionViewDidLoad() {	
		this.loading = false;
		let loader = this.loadingCtrl.create();
		loader.present().then(()=>{
			try {
				this.ecomBadgesApi.GetAllEarnersBadges(this.userId).subscribe(
					badges => {
						this.userBadges = badges;
						this.downloadBadges();
						console.log(this.userBadges);
						this.downloadOrganisationLogo();
						if(this.userBadges.length == 0){
							this.zeroData = true;
						}
						else{					
							this.displayData = true;
						}
						this.lastSyncDate = "<span class='active'>Passes are valid for today: "+ this.getDate() +"</span>";
						localStorage.setItem("lastSyncDate", this.getDate());
						loader.dismiss();			
					},
					error => {
						this.storage.get('OfflineBadges').then((val) => {
							console.log(val);
							if(val != null) {
								this.userBadges = [];
								for (let i = 0; i < val.length; i++) {	
									this.userBadges.push(val[i]);
								}
								this.displayData = true;
							}
							else{	
								this.zeroData = true;				
							}
							loader.dismiss();
						}).catch(
						function (error) {
							this.log.error(error);
							if(error){
								this.zeroData = true;
								this.displayData = false;
							}
							loader.dismiss();
						});
					}				
				);
			}catch (e) {
				this.storage.get('OfflineBadges').then((val) => {
					console.log(val);
					if(val != null) {
						this.userBadges = [];
						for (let i = 0; i < val.length; i++) {	
							this.userBadges.push(val[i]);
						}
						this.displayData = true;
					}
					else{	
						this.zeroData = true;				
					}
					loader.dismiss();
				}).catch(
				function (error) {
					this.log.error(error);
					if(error){
						this.zeroData = true;
						this.displayData = false;
					}
					loader.dismiss();
				});
			}
		});	
	}

	viewBadge(id){
		this.navCtrl.push(BadgePage, id);
	}

	getBase64ImageFromURL(url: string) {
		return Observable.create((observer: Observer<string>) => {
		let img = new Image();
		img.crossOrigin = 'Anonymous';
		img.src = url;
		if (!img.complete) {
			img.onload = () => {
				observer.next(this.getBase64Image(img));
				observer.complete();
			};
			img.onerror = (err) => {
				observer.error(err);
			};
		} else {
			observer.next(this.getBase64Image(img));
			observer.complete();
		}
		});
	}

	getBase64Image(img: HTMLImageElement) {
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;
		var ctx = canvas.getContext("2d");
		ctx.drawImage(img, 0, 0);
		var dataURL = canvas.toDataURL("image/png");
		return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
	}

	refreshPage()
	{
		this.loading = true;
		window.location.reload();
	}

	downloadOrganisationLogo(){
		let imageUrl = 'https://ecomstorageproduction.blob.core.windows.net/' + this.imageContainer + '/Organisations/' + this.userBadges[0].organisation.uniqueKey + '/Logo/' + this.userBadges[0].organisation.iconFileName;							
				console.log(imageUrl);
		let img = this.getBase64ImageFromURL(imageUrl).subscribe(
					base64data => {
						var base64Img = 'data:image/jpg;base64,'+ base64data;
						this.storage.set("OrganisationLogo", base64Img); 
						this.organisationLogo = base64Img;
					}
				);
	}

	downloadBadges(){	
		this.loading = true;			
		var arr = [];
		for (let i = 0; i < this.userBadges.length; i++) {
			console.log(this.userBadges[i]);

			let imageUrl = 'https://ecomstorageproduction.blob.core.windows.net/' + this.imageContainer + '/Organisations/' + this.userBadges[i].organisation.uniqueKey + '/BadgeIcons/' + this.userBadges[i].badgeIcon.filename;							
			let img = this.getBase64ImageFromURL(imageUrl).subscribe(
				base64data => {
					this.base64Image = 'data:image/jpg;base64,'+ base64data;
					this.userBadges[i].filename = this.base64Image;
					console.log(this.userBadges[i].organisation);
					var data = {
						badgeCode: this.userBadges[i].badgeCode,
						id : this.userBadges[i].id,
						name : this.userBadges[i].name,
						filename : this.base64Image,
						description : this.userBadges[i].description,
						expires : this.userBadges[i].expires,
						expiryDate : this.userBadges[i].expiryDate,
						organisation: {
							id:	this.userBadges[i].organisation.id,
							description: this.userBadges[i].organisation.description,
							name: this.userBadges[i].organisation.name
						}
					};
					arr.push(data);
					this.storage.set("OfflineBadges", arr); 
					this.storage.get("OfflineBadges").then(a => {
						console.log(a);
					});
				}
			);
		}	
		this.loading = false;	
	}

	getDate(){
		var today = new Date();
		var dd = today.getDate();

		var mm = today.getMonth()+1; 
		var yyyy = today.getFullYear();

		var dds = "";
		var mms = "";
		var yyyys = "";

		if (dd < 10) 
			dds = '0'+dd;
		else
			dds = dd.toString();

		if (mm < 10) 
			mms = '0'+mm;
			else
			mms = mm.toString();

		yyyys = yyyy.toString();

		return dds+"/"+mms+"/"+yyyys;
	}

	async presentLogoutChoice() {
		const alert = await this.alertCtrl.create({
		  title: 'Logout',
		  message: '<p>Are you sure that you want to log out? If you log out, you will need to launch the app via an email with your pass authentication link?</p>',
		  buttons: [
			{
			  text: 'No',
			  role: 'cancel',
			  cssClass: 'secondary',
			  handler: (err) => {
				//
			  }
			}, {
			  text: 'Yes',
			  handler: () => {
				let loader = this.loadingCtrl.create();
				loader.present().then(() => {
				this.storage.remove('username');
				this.storage.remove('accessToken');
				this.storage.remove("OfflineBadges");
				localStorage.removeItem("USR");
				this.navCtrl.setRoot(LoginPage);
				loader.dismiss().catch(err => console.log(err));
				}).catch(
				function (error) {
					loader.dismiss().catch(err => console.log(err))
				});
			  }
			}
		  ]
		});
	
		await alert.present();
	  }

    logout() {
		this.presentLogoutChoice();
	}
}


// WEBPACK FOOTER //
// ./src/pages/badges/badges.ts